import React from 'react';
import {inSelection} from './overlaps.js';

export const useSelection = ({elements}) => {
    const getSelection = ({x1,y1,x2,y2}) => {
        return Object.keys(elements.current)
            .map(id => ({
                element: elements.current[id],
                id: id}))
            .filter(
                ({element, id}) => inSelection(element.current, x1, y1, x2, y2));
    };

    return {getSelection};
};
